var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"testdemo"}},[_c('div',{ref:"remotewrap",staticClass:"remote-s"},[_c('video',{staticClass:"remote-video",attrs:{"poster":require("@/assets/back.jpg"),"id":"remote-video","muted":"","autoplay":"","playsinline":""},domProps:{"muted":true}})]),_c('div',{staticClass:"options"})])
}
var staticRenderFns = []

export { render, staticRenderFns }